import {useEffect, useMemo} from 'react';

import {generatePath, useNavigate} from 'react-router-dom';
import * as createPrsStore from 'store/post-results-services/prsSlice';
import {ROUTES, mapServerError} from 'core';
import {useAppDispatch, useAppSelector} from 'store/hooks';

import {ServerError} from '@britishcouncil/react-forms';

import {useCreatePrsMutation} from "../../store/post-results-services/postResultsServicesApi";
import {SelectPrsPaymentMethodParams} from "../post-results-services/views/SelectPrsPaymentMethod";

export const useCreatePrsSubmit = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const components = useAppSelector(createPrsStore.selectCreatePrsStep1Values);

    const [create, createData] = useCreatePrsMutation();
    
    const submit = () => {
        if (components) {
            create({
                ...components,
                components: components.components.map(c => c.value)
            });
        }
    };

    const serverErrors = useMemo<ServerError[]>(
        () => (!createData.isError ? [] : mapServerError(createData.error)),
        [createData]
    );

    useEffect(() => {
        if (createData.isSuccess) {
            const params : SelectPrsPaymentMethodParams = {
                prsIds: [`${createData.data}`],
                navigationSource: "newPrs"
            }

            navigate(generatePath(ROUTES.SELECT_PAYMENT_METHOD_POST_RESULTS_SERVICES, {paramsBase64String: btoa(JSON.stringify(params))}));
        }
    }, [createData.data, createData.isSuccess, dispatch, navigate]);

    return {
        submit,
        serverErrors,
        isSubmitting: createData.isLoading,
    };
};
